var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9102_19577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 2.66667C7.244 2.66667 9.33333 2.06971 9.33333 1.33333C9.33333 0.596954 7.244 0 4.66667 0C2.08934 0 0 0.596954 0 1.33333C0 2.06971 2.08934 2.66667 4.66667 2.66667Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 5.66693C7.244 5.66693 9.33333 5.07027 9.33333 4.3336V2.82227C7.864 3.6096 5.336 3.66693 4.66667 3.66693C3.99733 3.66693 1.46933 3.6096 0 2.82227V4.3336C0 5.07027 2.08933 5.66693 4.66667 5.66693Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 12.5803V14.5736C5.82 14.6336 5.25333 14.667 4.66667 14.667C2.08667 14.667 0 14.067 0 13.3336V11.8203C1.46667 12.607 4 12.667 4.66667 12.667C4.95333 12.667 5.58667 12.6536 6.33333 12.5803Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40667 9.57365C6.38667 9.63365 6.37333 9.70698 6.36 9.77365L6.33333 9.75365V11.5736C5.82 11.6336 5.25333 11.667 4.66667 11.667C2.08667 11.667 0 11.067 0 10.3336V8.82031C1.46667 9.60698 4 9.66698 4.66667 9.66698C4.96 9.66698 5.62667 9.65365 6.40667 9.57365Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 6.66693C3.99733 6.66693 1.46933 6.6096 0 5.82227V7.3336C0 8.07027 2.08933 8.66693 4.66667 8.66693C7.244 8.66693 9.33333 8.07027 9.33333 7.3336V5.82227C7.864 6.6096 5.336 6.66693 4.66667 6.66693Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 11.3327C14.0606 11.3327 16.0007 10.7357 16.0007 9.99935C16.0007 9.26297 14.0606 8.66602 11.6673 8.66602C9.27408 8.66602 7.33398 9.26297 7.33398 9.99935C7.33398 10.7357 9.27408 11.3327 11.6673 11.3327Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 13.6663C14.0607 13.6663 16.0007 13.0696 16.0007 12.3329V11.4883C14.6367 12.2763 12.2887 12.3329 11.6673 12.3329C11.046 12.3329 8.69798 12.2756 7.33398 11.4883V12.3329C7.33398 13.0696 9.27398 13.6663 11.6673 13.6663Z",
    fill: "#2C72DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 14.6669C11.046 14.6669 8.69798 14.6096 7.33398 13.8223V14.6669C7.33398 15.4036 9.27398 16.0003 11.6673 16.0003C14.0607 16.0003 16.0007 15.4036 16.0007 14.6669V13.8223C14.6367 14.6096 12.2887 14.6669 11.6673 14.6669Z",
    fill: "#2C72DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9102_19577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.4fa8d59b8379d6d09254d7a6698f485e.svg";
export { ForwardRef as ReactComponent };